import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';
import { LyftDispatchReceiptCharge } from './lyft-dispatch-receipt-charge';
import { LyftDispatchReceiptLineItem } from './lyft-dispatch-receipt-line-item';

@inheritSerialization(AbstractModel)
export class LyftDispatchRideReceipt extends AbstractModel {
  @autoserialize
  lyftDispatchRideId: number;

  @autoserialize
  amount: number;

  @autoserialize
  currency: string;

  @autoserializeAs(LyftDispatchReceiptLineItem)
  lyftDispatchReceiptLineItems: Array<LyftDispatchReceiptLineItem>;

  @autoserialize
  description: string;

  lyftDispatchReceiptCharges: Array<LyftDispatchReceiptCharge>;
}
